/* eslint-disable no-console */
import FonemaModelMC from '../../../models/FonemaModelMC';

/**
 * Crea un evento de llamada en Fonema a partir de callData y metadata.
 *
 * @param {Object} params
 * @param {Object} params.callData - Datos de la llamada (incluye callId y callerNumber)
 * @param {number|string} params.customerId - ID del cliente asociado (opcional)
 * @param {('incoming'|'outgoing')} params.direction - Dirección de la llamada
 * @param {string} params.registerNumber - Número con el que se registró el handler / número local
 */
const createFonemaCallEvent = async ({
  callData,
  customerId,
  endedReason,
  status = 'in_call'
}) => {
  try {
    const isIncoming = callData.callDirection === 'incoming';

    const fromNumber = isIncoming
      ? callData.callerNumber
      : callData.registerNumber;

    const toNumber = isIncoming
      ? callData.registerNumber
      : callData.callerNumber;

    await FonemaModelMC.createCallEvent({
      call_id: callData.callId,
      from: fromNumber,
      to: toNumber,
      direction: callData.callDirection,
      customer_id: customerId,
      status,
      channel: 'whatsapp_voice',
      ended_reason: endedReason
    });
  } catch (error) {
    console.error('Error creating CallEvent', error);
  }
};

export default createFonemaCallEvent;
